import { apiClient } from "./apiClient";

export const suppliersApi = {
  list: () => apiClient.get("/suppliers").then((r) => r.data),
  create: (payload) => apiClient.post("/suppliers", payload).then((r) => r.data),
};
